__turbopack_context__.v({
  "counter": "Ai-module__rpSoNW__counter",
  "counterNearLimit": "Ai-module__rpSoNW__counterNearLimit",
});
